import { NavLink, useLocation} from 'react-router-dom'
import {
  ChangeStore,
  NavCurrentUser,
  NavStoreName,
  SainsburysLogo
} from './nav'
import SignOutButton from '../auth/SignOutButton'
import {
  Header as LunaHeader,
  HeaderLogo,
  HeaderNav,
  HeaderMainBar,
  HeaderGlobalItem
} from '@sainsburys-tech/luna-header'
import HeaderGlobalBar from './CustomHeaderGlobalBar'
import { Caption } from '@sainsburys-tech/luna-typography'
import { Role } from '../../types/Permission/IRoles'
import useRoles from '../../hooks/useRoles'

const NavHeader = () => {

  const { pathname } = useLocation()
  const { apiRoles } = useRoles();

  const hasManagerOrSecurityGuardRole = apiRoles.some((role) => role.name === Role.Manager || role.name === Role.SecurityGuard);

  return (
    <LunaHeader divided hasGlobalBar hasMainBar>
      <HeaderGlobalBar
        label="Group navigation"
        element="nav"
        className={undefined}
        size={undefined}
      >
        <HeaderGlobalItem>
          <SainsburysLogo />
        </HeaderGlobalItem>
        <HeaderGlobalItem align="right" drawer="true" tabbar="md">
          <span id="s-user-store">
            <NavCurrentUser /> in <NavStoreName />
          </span>
        </HeaderGlobalItem>
        <HeaderGlobalItem>
          <span id="s-nav-link-stores">
            <ChangeStore />
          </span>
        </HeaderGlobalItem>
        <HeaderGlobalItem>
          <span id="s-nav-link-signOut">
            <SignOutButton />
          </span>
        </HeaderGlobalItem>
      </HeaderGlobalBar>

      <HeaderMainBar size="nav">
        <HeaderLogo>
        <NavLink id="s-logo" to="/" style={{ textDecoration: 'none' }}>
          Security Assist
        </NavLink>

        </HeaderLogo>

        <HeaderNav openDropdownOnHover drawer tabBar="sm" label="Main">
          {[
            <NavLink key="incidents" id="s-nav-link-accidents" to="/" active={pathname === '/'}>
              Reported incidents
            </NavLink>,
            hasManagerOrSecurityGuardRole && (
              <NavLink key="guarding-daily-activities" id="s-nav-link-accidents" to="/guarding-daily-activities" active={pathname === '/guarding-daily-activities'}>
                Guarding daily activities
              </NavLink>
            ),
            <NavLink key="drafts" id="s-nav-link-accidents" to="/drafts" active={pathname === '/drafts'}>
              My Drafts
            </NavLink>
          ].filter(Boolean)}
        </HeaderNav>

        <HeaderNav align="center" drawer className="s-u-hidden@max-nav">
          <Caption>
            <NavCurrentUser /> &nbsp;in&nbsp; <NavStoreName />
          </Caption>
          <Caption>
            <ChangeStore />
          </Caption>
          <Caption>
            <SignOutButton />
          </Caption>
        </HeaderNav>
      </HeaderMainBar>
    </LunaHeader>
  )
}
export default NavHeader